import React from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuxPlayer from "@mux/mux-player-react";

interface MuxPlayerOverlayProps {
  open: boolean;
  onClose: () => void;
  mux_playback_id?: string | null;
  talktape_video_title?: string;
}

const MuxPlayerOverlay: React.FC<MuxPlayerOverlayProps> = ({
  open,
  onClose,
  mux_playback_id,
  talktape_video_title,
}) => {
  if (!mux_playback_id) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <div style={{ position: "relative", backgroundColor: "black", padding: 16 }} onClick={(e: React.MouseEvent) => e.stopPropagation()} >
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          sx={{ position: "absolute", top: 8, right: 8, color: "white", zIndex: 10 }}
        >
          <CloseIcon />
        </IconButton>

        <MuxPlayer
          playbackId={mux_playback_id}
          streamType="on-demand"
          metadata={{
            video_id: mux_playback_id,
            video_title: talktape_video_title || "Untitled",
          }}
          muted={false}
          style={{ width: "100%", borderRadius: 8, opacity: 1 }}
          {...{
            controls: true,
            autoplay: true,
          }}
        />
      </div>
    </Dialog>
  );
};

export default MuxPlayerOverlay;
